// Hide Header on scroll-down & Show on scroll-up
/*
let headerHeight = document.querySelector('#myheader').offsetHeight;
let headerHeightPX = "-" + headerHeight + "px";
let prevScrollpos = window.pageYOffset;

$(document).scroll(function(){
  if ( window.pageYOffset > 10 ){
    window.onscroll = function() {
    let currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        document.getElementById("myheader").style.top = "0";
      } 
      // Fix for Safari & other mobile browsers for negative YOffset values
      else if ( window.pageYOffset <= 0 ) {
        document.getElementById("myheader").style.top = "0";
      }  
      else {
        document.getElementById("myheader").style.top = headerHeightPX;
      }
      prevScrollpos = currentScrollPos;
    }
  } 
});
*/

console.log("custom loaded");

// ============================================================
// Fertige Anprobeboxen (Collection "anprobeboxen") sind abgeschlossene
// Produkte: sobald eine davon im Warenkorb liegt, darf nichts anderes mehr
// hinzugefügt werden - nur der Tausch gegen eine andere fertige Box ist erlaubt.
// Da es im Theme mehrere unabhängige Add-to-Cart-Wege gibt (PDP-Formular via
// theme.AjaxProduct/fetch, sowie mehrere direkte $.ajax-Aufrufe für
// Collection-Quick-Add und die "Anprobebox selbst zusammenstellen"-Flows),
// wird hier zentral auf Netzwerkebene (fetch + $.ajax) vor jedem POST auf
// /cart/add geprüft, statt jeden Button einzeln abzusichern.
// ============================================================
(function () {
  function boxVariantIds() {
    return (window.theme && window.theme.anprobeboxVariantIds) || [];
  }

  function isBoxVariant(id) {
    return boxVariantIds().indexOf(Number(id)) > -1;
  }

  function exclusiveMessage() {
    return (
      (window.theme && window.theme.strings && window.theme.strings.anprobeboxExclusive) ||
      "This ready-made try-on box can't be combined with other products."
    );
  }

  function idsFromQueryString(qs) {
    var ids = [];
    var params = new URLSearchParams(qs);
    if (params.has("id")) {
      ids.push(params.get("id"));
    }
    params.forEach(function (value, key) {
      if (/^items\[\d+\]\[id\]$/.test(key)) {
        ids.push(value);
      }
    });
    return ids.map(Number);
  }

  function idsFromFetchBody(body) {
    try {
      if (typeof body === "string") {
        return idsFromQueryString(body);
      }
    } catch (e) {
      console.error("anprobebox guard: could not parse fetch body", e);
    }
    return [];
  }

  function idsFromJqueryData(data) {
    try {
      if (!data) {
        return [];
      }
      if (typeof data === "string") {
        return idsFromQueryString(data);
      }
      var ids = [];
      if (data.id != null) {
        ids.push(Number(data.id));
      }
      if (Array.isArray(data.items)) {
        data.items.forEach(function (item) {
          if (item && item.id != null) {
            ids.push(Number(item.id));
          }
        });
      }
      return ids;
    } catch (e) {
      console.error("anprobebox guard: could not parse ajax data", e);
      return [];
    }
  }

  function removeCartLine(key) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  // Resolves { allowed: true } or { allowed: false, message: "..." }.
  // Performs the actual box swap (removing the old box line item) as a
  // side effect when a box-for-box exchange is allowed.
  function checkAnprobeboxGuard(addedVariantIds) {
    if (!boxVariantIds().length || !addedVariantIds.length) {
      return Promise.resolve({ allowed: true });
    }

    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var existingBoxItem = null;
        var hasNonBoxItem = false;

        cart.items.forEach(function (item) {
          if (isBoxVariant(item.variant_id)) {
            existingBoxItem = existingBoxItem || item;
          } else {
            hasNonBoxItem = true;
          }
        });

        var addingBoxVariant = addedVariantIds.some(isBoxVariant);
        var addingNonBoxVariant = addedVariantIds.some(function (id) {
          return !isBoxVariant(id);
        });

        // Nothing box-related on either side: unrelated add, let it through.
        if (!existingBoxItem && !addingBoxVariant) {
          return { allowed: true };
        }

        // Swapping the existing box for a different one, cart otherwise clean.
        if (
          addingBoxVariant &&
          !addingNonBoxVariant &&
          !hasNonBoxItem &&
          existingBoxItem
        ) {
          return removeCartLine(existingBoxItem.key).then(function () {
            return { allowed: true };
          });
        }

        // First item(s) added to an empty cart, no mixing involved.
        if (
          addingBoxVariant &&
          !addingNonBoxVariant &&
          !hasNonBoxItem &&
          !existingBoxItem
        ) {
          return { allowed: true };
        }

        return { allowed: false, message: exclusiveMessage() };
      })
      .catch(function (e) {
        console.error("anprobebox guard: cart check failed, allowing add", e);
        return { allowed: true };
      });
  }

  // --- fetch() interception (covers theme.AjaxProduct / PDP form) ---
  if (window.fetch) {
    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var method = ((init && init.method) || "GET").toUpperCase();

      if (typeof url !== "string" || url.indexOf("/cart/add") === -1 || method !== "POST") {
        return originalFetch(input, init);
      }

      var addedVariantIds = idsFromFetchBody(init && init.body);

      return checkAnprobeboxGuard(addedVariantIds).then(function (result) {
        if (result.allowed) {
          return originalFetch(input, init);
        }
        return new Response(
          JSON.stringify({
            status: 422,
            message: result.message,
            description: result.message,
          }),
          { status: 200, headers: { "Content-Type": "application/json" } }
        );
      });
    };
  }

  // --- $.ajax() interception (covers collection quick-add / Anprobebox-Aufbau flows) ---
  if (window.jQuery) {
    var $ = window.jQuery;
    var originalAjax = $.ajax;

    $.ajax = function (urlOrSettings, maybeSettings) {
      var settings =
        typeof urlOrSettings === "string"
          ? $.extend({}, maybeSettings, { url: urlOrSettings })
          : $.extend({}, urlOrSettings);

      var url = settings.url || "";
      var method = (settings.type || settings.method || "GET").toUpperCase();

      if (url.indexOf("/cart/add") === -1 || method !== "POST") {
        return originalAjax.apply($, arguments);
      }

      var addedVariantIds = idsFromJqueryData(settings.data);
      var callArgs = arguments;

      return $.when(checkAnprobeboxGuard(addedVariantIds)).then(function (result) {
        if (result.allowed) {
          return originalAjax.apply($, callArgs);
        }
        if (typeof settings.error === "function") {
          settings.error({ responseJSON: { description: result.message } }, "error", "Forbidden");
        } else {
          alert(result.message);
        }
        return $.Deferred().reject({ responseJSON: { description: result.message } }).promise();
      });
    };
  }
})();

// ============================================================
// PDP: Robust variant image switching
// Problem: theme.js dispatches variantImageChange/variantChange, but the
// native updateImageSet / updateVariantImage handlers rely on Flickity DOM
// child order (getThumbIndex) which goes stale once Flickity re-parents
// slides/thumbs (wrapAround clones etc.) - the wrong slide (or none) gets
// shown after the first click. Originally only worked around for Clip-On
// products; the same failure hits any multi-color product with per-variant
// images (e.g. Try-On), so this is no longer scoped to one product type.
//
// Fix: listen to the document-level "variant:change" event (always
// dispatched), find the matching slide via the THUMB's data-id, and
// drive Flickity directly via its public selectCell API.
// ============================================================
(function () {
  function getFlickityInstance(sliderEl) {
    if (typeof Flickity !== "undefined" && Flickity.data) {
      var f = Flickity.data(sliderEl);
      if (f) return f;
    }
    // Theme wraps Flickity in theme.Slideshow — try the jQuery data hook used by Flickity
    if (window.jQuery) {
      var $f = window.jQuery(sliderEl).data("flickity");
      if ($f) return $f;
    }
    return null;
  }

  function findSlideForVariant(scope, variant) {
    if (!variant) return null;
    var mediaId = (variant.featured_media && variant.featured_media.id) || null;
    var imageId = (variant.featured_image && variant.featured_image.id) || null;
    var lookupId = mediaId || imageId;
    if (!lookupId) return null;

    // The thumb has data-id=""; its data-index aligns with
    // the slide's data-index (both are forloop.index0 of product.media).
    var thumb = scope.querySelector('.product__thumb[data-id="' + lookupId + '"]');
    if (!thumb) return null;

    var slideIndex = thumb.getAttribute("data-index");
    if (slideIndex === null) return null;

    return scope.querySelector('.product-main-slide[data-index="' + slideIndex + '"]');
  }

  function switchSlide(variant) {
    var scope = document.querySelector('[data-product-images]') || document;
    var sliderEl = scope.querySelector('[data-product-photos]');
    if (!sliderEl) return;

    var slide = findSlideForVariant(scope, variant);
    if (!slide) return;

    var flkty = getFlickityInstance(sliderEl);
    if (!flkty) return;

    // selectCell accepts a DOM element and handles filtered/unfiltered cells.
    if (typeof flkty.selectCell === "function") {
      flkty.selectCell(slide, false, false);
      return;
    }
    // Fallback: select by numeric index among current cells.
    var cells = (flkty.cells || []).map(function (c) { return c.element; });
    var idx = cells.indexOf(slide);
    if (idx >= 0 && typeof flkty.select === "function") {
      flkty.select(idx, false, false);
    }
  }

  // Debounce so rapid clicks don't fight each other
  var pending = null;
  function onVariantChange(evt) {
    if (!evt || !evt.detail || !evt.detail.variant) return;
    var variant = evt.detail.variant;
    if (pending) cancelAnimationFrame(pending);
    pending = requestAnimationFrame(function () {
      pending = null;
      try { switchSlide(variant); } catch (e) { console.warn("[variant image switch]", e); }
    });
  }

  document.addEventListener("variant:change", onVariantChange);
  // Also listen on document for the section-level event in case bubbling differs
  document.addEventListener("variantChange", onVariantChange, true);
})();

// Fixed MantiManti

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

$(window).scroll(function () {
  $("#mantimanti").each(function () {
    if (isScrolledIntoView(this) === true) {
      $(this).addClass("fixed-manti");
    }
  });
});

$(".mantimanti-close").click(function () {
  $("#mantimanti").hide(100);
});

// ATC Collection

$(document).on("click", ".js_ATC_btn", function () {
  var _this = $(this),
    form_data = $(this).parents(".collection_product_form").serialize();

  $(_this).addClass("btn--loading");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: form_data,
    success: function (data) {
      $(_this).removeClass("btn--loading");
      if (data.quantity > 0) {
        $(_this).text("Remove from Cart").addClass("js_remove_from_cart_btn");
      } else {
        $(_this).text("Add to Cart").removeClass("js_remove_from_cart_btn");
      }
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: null,
            addToCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      $(_this).removeClass("btn--loading");
      console.log(error.responseJSON.description);
    },
  });
});

$(document).on("click", ".js_ATC_btn", function () {
  var _this = $(this),
    variant_id = $(this)
      .closest(".collection_product_form")
      .find('[name="id"]')
      .val();

  $(_this).addClass("btn--loading");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      quantity: 0,
      id: variant_id,
    },
    success: function (data) {
      $(_this).removeClass("btn--loading");
      if (data.item_count > 0) {
        $(_this).text("Entfernen").addClass("js_remove_from_cart_btn");
      } else {
        $(_this)
          .text("Zum Probierset hinzufügen")
          .removeClass("js_remove_from_cart_btn");
      }
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:removed", {
          detail: {
            product: null,
            removeFromCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      $(_this).removeClass("btn--loading");
      console.log(error.responseJSON.description);
    },
  });
});

// Open Dropdown on Hover for Try-On

$(".variant_selectors select").hover(
  function () {
    $(this).attr("size", $("option").length);
  },
  function () {
    $(this).attr("size", 1);
  }
);

// FF: Try On Kit - Add to Cart Button + Remove from Cart Button + Update Cart Button
$(document).on(
  "change",
  ".new_customization .variant_option .single_variant input",
  function () {
    if (
      $(this)
        .parents(".new_customization")
        .find(".single_variant input:checked").length
    ) {
      $(this)
        .parents(".new_customization")
        .find(".add_to_cart_JS")
        .removeClass("disable_btn");
    } else {
      $(this)
        .parents(".new_customization")
        .find(".add_to_cart_JS")
        .addClass("disable_btn");
    }
  }
);

$(document).on(
  "click",
  ".new_customization .variant_option .add_to_cart_JS",
  function () {
    var variant_arr = [],
      $this_add_to_cart_JS = $(this);
    $(this)
      .parents(".variant_option")
      .find(".variant_option_box .single_variant input:checked")
      .each(function (index, single_val) {
        variant_arr.push({ quantity: 1, id: parseInt($(single_val).val()) });
      });
    let variant_add_arry = {
      items: variant_arr,
    };
    $(this).text("Hinzufügen...");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: variant_add_arry,
      dataType: "json",
      success: function (success) {
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".add_product")
          .addClass("hide");
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".variant_option")
          .addClass("hide");
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".remove_product")
          .removeClass("hide");
        $($this_add_to_cart_JS).text("Auswahl hinzufügen");
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: null,
              addToCartBtn: null,
            },
          })
        );
      },
      error: function (error) {
        $($this_add_to_cart_JS).text("Auswahl hinzufügen");
        alert(error.responseJSON["description"]);
      },
    });
  }
);

$(document).on("click", ".new_customization .remove_product", function () {
  var remove_variant = {},
    $this_remove_product = $(this);
  $(this)
    .parents(".new_customization")
    .find(".variant_option_box .single_variant input:checked")
    .each(function (index, single_val) {
      remove_variant[parseInt($(single_val).val())] = 0;
    });
  let remove_added_var = {
    updates: remove_variant,
  };
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: remove_added_var,
    dataType: "json",
    success: function (success) {
      $($this_remove_product)
        .parents(".new_customization")
        .find(".add_product")
        .removeClass("hide");
      $($this_remove_product)
        .parents(".new_customization")
        .find(".variant_option")
        .removeClass("hide");
      $($this_remove_product).addClass("hide");
      $($this_remove_product)
        .parents(".new_customization")
        .find(".variant_option_box .single_variant input:checked")
        .each(function (index, single_val) {
          $(this)
            .parents(".new_customization")
            .find(".add_to_cart_JS")
            .addClass("disable_btn");
          $(single_val).prop("checked", false);
        });
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: null,
            addToCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      alert(error.responseJSON["description"]);
    },
  });
});

// ATC PDP - Try On Product on PDP
/*
$(document).on('click', '.js_ATC_btn_pdp', function(){
  
  var _this = $(this),
      variant_id = 46854347063643;

  $(_this).addClass('btn--loading');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: 1,
      id: variant_id
    },
    error:function(error){
      $(_this).removeClass('btn--loading');
      console.log(error.responseJSON.description);
    }
  });
});  
*/

function addCart(id) {
  jQuery.post(window.Shopify.routes.root + "cart/add.js", {
    items: [
      {
        quantity: 1,
        id: id,
      },
    ],
  }).done(function() {
    var url = $(location).attr("href");
    if (url.indexOf("?added") >= 0) {
      window.location.href = url;
      //code to update and open ajax cart
      var cart = new theme.CartDrawer();
      cart.init();
      cart.open();
    } else {
      window.location.href = url + "?added";
      //code to update and open ajax cart
      var cart = new theme.CartDrawer();
      cart.init();
      cart.open();
    }
  });
}

$(document).ready(function () {
  if (window.location.href.indexOf("added") > -1) {
    //code to update and open ajax cart
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  }
});

// Lens Advisor

document.addEventListener("LensAdvizor:init:complete", function () {
  LensAdvizor.options.settings.post_add_to_cart = true;
  LensAdvizor.postAddToCart = function () {
    //code to update and open ajax cart
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  };
});

/* Fitting Box - Virtual Try On */
/*
window.fitmixInstance = FitMix.createWidget("my-fitmix-container", params, function() {
  console.log('FMI created.');
});

window.onload = function () {
  var params = {
    apiKey: "SXeynuamTfjaZS7mmzQGNmy1IcwWUEupbBFQnqnv", 
    popupIntegration: {
      centeredHorizontal: true,
      centeredVertical: true,
      width: "780px",
      height: "560px",
    },
  };
};
*/

/*
window.onload = function() { 
  window.fitmixInstance = FitMix.createWidget('fitmix-container', params, function() {
  }
}
*/
// New Cart

async function returnCart() {
  try {
    const response = await fetch("/cart.json");
    if (!response.ok) {
      throw new Error("Failed to fetch cart data");
    }

    const cartData = await response.json();
    const cartItems = cartData.items || [];
    const cartPriceBetween0and488 = cartData.total_price <= 488;

    // Check if any cart item has "Try On" in its product title
    const tryOnItems = cartItems.filter((item) => {
      return (
        item.product_title &&
        item.product_title.toLowerCase().includes("try on") &&
        !item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      );
    });

    const tryOnSelectionItems = cartItems.filter((item) => {
      return (
        item.product_title &&
        item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      );
    });

    const cartNonTryOn = cartItems.filter((item) => {
      return (
        item.product_title &&
        !item.product_title.toLowerCase().includes("try on")
      );
    });

    // Determine the number of try-on items in cart
    const isOneTryOnItem = tryOnItems.length === 1;
    const isTwoTryOnItem = tryOnItems.length === 2;
    const isThreeTryOnItem = tryOnItems.length === 3;
    const isFourTryOnItem = tryOnItems.length === 4;
    const isFiveTryOnItem = tryOnItems.length === 5;
    const isNoTryOnItem = cartNonTryOn.length > 0;

    return {
      cartData,
      tryOnItems,
      isNoTryOnItem,
      tryOnSelectionItems,
      cartPriceBetween0and488,
    };
  } catch (error) {
    throw error;
  }
}

returnCart()
  .then((result) => {
    const cartData = result.cartData;

    const isNoTryOnItem = result.isNoTryOnItem;

    const reorderedCartItems = cartData.items.sort((a, b) => {
      const aIsTryOn =
        a.product_title && a.product_title.toLowerCase().includes("try on");
      const bIsTryOn =
        b.product_title && b.product_title.toLowerCase().includes("try on");

      if (aIsTryOn && !bIsTryOn) {
        return -1;
      }
      if (!aIsTryOn && bIsTryOn) {
        return 1;
      }
      return 0;
    });

    // Update cartData.items with the reordered items
    cartData.items = reorderedCartItems;
    // There is a needed delay here so that the cart can first get built before reassigning a different order for all elements inside of it
    setTimeout(() => {
      setDOMOrder(reorderedCartItems);
    }, 650); // 400ms delay
  })
  .catch((error) => {
    console.error("Error:", error);
  });

document.addEventListener("cart:updated", function (evt) {
  returnCart()
    .then((result) => {
      const cartData = result.cartData;

      const isNoTryOnItem = result.isNoTryOnItem;
    })
    .catch((error) => {
      console.error(error);
    });
});

document.addEventListener("ajaxProduct:added", function (evt) {
  returnCart()
    .then((result) => {
      const cartData = result.cartData;
      const cartPriceBetween0and488 = cartData.total_price <= 488;
      const isNoTryOnItem = result.isNoTryOnItem;

      const reorderedCartItems = cartData.items.sort((a, b) => {
        const aIsTryOn =
          a.product_title && a.product_title.toLowerCase().includes("try on");
        const bIsTryOn =
          b.product_title && b.product_title.toLowerCase().includes("try on");

        if (aIsTryOn && !bIsTryOn) {
          return -1;
        }
        if (!aIsTryOn && bIsTryOn) {
          return 1;
        }
        return 0;
      });

      // Update cartData.items with the reordered items
      cartData.items = reorderedCartItems;
      // There is a needed delay here so that the cart can first get built before reassigning a different order for all elements inside of it
      setTimeout(() => {
        setDOMOrder(reorderedCartItems, cartPriceBetween0and488);
      }, 650); // 400ms delay
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated:", evt.detail.cart);

  // Fetch the updated cart data
  returnCart()
    .then((result) => {
      const cartData = result.cartData;
      const cartPriceBetween0and488 = cartData.total_price <= 488;

      // Sort the cart items
      const reorderedCartItems = cartData.items.sort((a, b) => {
        const aIsTryOn =
          a.product_title && a.product_title.toLowerCase().includes("try on");
        const bIsTryOn =
          b.product_title && b.product_title.toLowerCase().includes("try on");

        if (aIsTryOn && !bIsTryOn) {
          return -1;
        }
        if (!aIsTryOn && bIsTryOn) {
          return 1;
        }
        return 0;
      });

      // Update cartData.items with the reordered items
      cartData.items = reorderedCartItems;

      // Set the order property for each DOM element
      setTimeout(() => {
        setDOMOrder(reorderedCartItems, cartPriceBetween0and488);
      }, 650); // 400ms delay
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

function setDOMOrder(sortedCartItems, cartPriceBetween0and488) {
  let hasTryOnItem = false;
  let hasNonTryOnItem = false;
  let hasLenseItem = false;
  let lastTryOnIndex = -1;
  let tryOnSelectionItems = false;
  const linksForTryOnElement = document.getElementById("links--for-try-on");
  sortedCartItems.forEach((item, index) => {
    const itemElement = document.querySelector(
      `.cart__item[data-key="${item.key}"]`
    );

    if (itemElement) {
      if (
        item.product_title &&
        item.product_title.toLowerCase().includes("manti")
      ) {
        hasLenseItem = true;
      }
      if (
        item.product_title &&
        // Check if it has more empty spaces
        item.product_title.toLowerCase().includes("try on") &&
        !item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      ) {
        hasTryOnItem = true;
        lastTryOnIndex = index;
        itemElement.style.order = index;
      } else if (
        item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      ) {
        tryOnSelectionItems = true;
      } else {
        hasNonTryOnItem = true;
        itemElement.style.order = index + 2;
      }
    }
  });

  // Check if the element with id "additional-products--text" does not exist
  if (!document.getElementById("additional-products--text")) {
    if (hasTryOnItem && hasNonTryOnItem && !cartPriceBetween0and488) {
      console.log("Both try-on and non-try-on items in cart");
      // Create the new element
      const newElement = document.createElement("div");
      newElement.className = "cart-subheader padding--gutter";
      newElement.id = "additional-products--text";
      newElement.innerHTML = `<h4 style="margin-top: 14px;" class="albus h5">Weitere Artikel: </h4>`;
      newElement.style.order = lastTryOnIndex + 2;

      // Append the new element to the parent container
      const parentContainer = document.querySelector(".cart__items");
      if (parentContainer) {
        parentContainer.appendChild(newElement);
      }

      // Set the order for the links--for-try-on element
      if (linksForTryOnElement) {
        linksForTryOnElement.style.order = lastTryOnIndex + 1;
      }
      document.querySelector(".ajaxcart__subtotal").style.cssText = `
      font-size: inherit;
      font-style: normal;
      font-weight: inherit;
      line-height: inherit;
      letter-spacing: inherit;
`;
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.querySelector(".ajaxcart__subtotal").textContent =
        "ZWISCHENSUMME";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe:";
      document.getElementById("sidecart--state-subheading").style.display =
        "none";
    } else if (hasTryOnItem && !hasNonTryOnItem && !cartPriceBetween0and488) {
      console.log("Only try-on items in cart");
      // If there are only try-on items, set the links--for-try-on to be at the end
      linksForTryOnElement.style.order = lastTryOnIndex + 1;

      document.querySelector(".tryonproducts-text-container").style.display =
        "flex";
      document.querySelector(".ajaxcart__subtotal").textContent =
        "Du zahlst nur die Versandkosten";
      document.querySelector(".ajaxcart__subtotal").style.cssText = `
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 180% */
        letter-spacing: 1.275px;
`;
      // document.querySelector(".data--subtotal--text").textContent = "€ 4,90";
      document.getElementById("shippingIndicator").textContent =
        "Brillen zu Hause anprobieren";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "block";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Lege bis zu 5 Brillen in deine Anprobebox und probiere diese 7 Tage zu Hause.";
      document.getElementById("shipping-value-down").textContent = "€ 6,90";
    } else if (
      tryOnSelectionItems &&
      !hasNonTryOnItem &&
      !cartPriceBetween0and488
    ) {
      console.log("Only try-on selection items in cart");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      document.getElementById("shipping-value-down").textContent = "kostenlos";
    } else if (cartPriceBetween0and488) {
      console.log("Cart Price between 0 and 488");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>1,80€</span>";
      document.getElementById("shipping-value-down").textContent = "1,80€";
    } else {
      console.log("Only non-try-on items in cart");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Augen auf! Hier ist deine Bestellung";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("shipping-value-down").textContent = "kostenlos";

      if (hasLenseItem) {
        document.getElementById("sidecart--state-subheading").innerHTML =
          "Versand (3-7 Tage) <span  class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      } else {
        document.getElementById("sidecart--state-subheading").innerHTML =
          "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      }
    }
  }
}

// async function updateShippingCostDisplay() {
//   try {
//     const response = await fetch("/cart.json");
//     if (!response.ok) {
//       throw new Error("Failed to fetch cart data");
//     }

//     const cartData = await response.json();
//     const cartValue = cartData.total_price || 0; // Assuming total_price is in cents

//     // Select the element(s) with the class 'shippingValue'
//     const shippingCostElements = document.querySelectorAll(".shippingValue");

//  /*
//     // Update the text content based on the cart value
//     shippingCostElements.forEach(element => {
//       element.textContent = cartValue < 5000 ? "4,90€" : "kostenlos"; // Assuming the threshold is 50€ (5000 cents)
//     });
// */

// // OpenAI generated multiple case statements instead of if for lower shipping fee for small spare parts (15.06.2024)
//     shippingCostElements.forEach(element => {
//       let shippingCost;

//       if (cartValue === 0) {
//         shippingCost = "4,90€";
//       } else if (cartValue >= 1 && cartValue <= 489) {
//         shippingCost = "1,80€";
//       } else if (cartValue >= 490 && cartValue < 5000) {
//         shippingCost = "4,90€";
//       } else {
//         shippingCost = "kostenlos";
//       }

//       element.textContent = shippingCost;
//     });

//   } catch (error) {
//     console.error("Error updating shipping cost display:", error);
//   }
// }

// Call the function to update the shipping cost display
// updateShippingCostDisplay();

// Optionally, listen for cart updates to refresh the shipping cost display
// document.addEventListener("cart:updated", updateShippingCostDisplay);

// // Kostenlos / 4,90 Shipping Costs in Cart

// function checkAndUpdateShippingCost() {
//   setTimeout(() => {
//     fetch("/cart.json")
//       .then(response => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch cart data");
//         }
//         return response.json();
//       })
//       .then(cartData => {
//         const cartValue = cartData.total_price || 0; // Assuming total_price is in cents
//         const shippingCostText = cartValue >= 5000 ? "kostenlos" : "€ 4,90";
//         const shippingCostElements = document.querySelectorAll(".shippingValue");

//         shippingCostElements.forEach(element => {
//           element.textContent = shippingCostText;
//         });
//       })
//       .catch(error => {
//         console.error("Error updating shipping cost:", error);
//       });
//   }, 700);
// }

// // Run on page load
// document.addEventListener("DOMContentLoaded", checkAndUpdateShippingCost);

// // Run when the cart updates
// document.addEventListener("cart:updated", checkAndUpdateShippingCost);

// // Run when a product is added to the cart
// document.addEventListener("ajaxProduct:added", checkAndUpdateShippingCost);

// ============================================================
// Bügel-Zuordnung: PDP für "bugel-3d-kollektion-austausch"
// Wenn Variante "Montiert: Ja" gewählt ist, muss der Kunde
// im Dropdown auswählen, an welche Brille im Warenkorb
// der Bügel montiert werden soll. Auswahl wird als
// Line Item Property "Für Brille" mitgesendet.
// ============================================================
(function () {
  var SELF_HANDLE = "bugel-3d-kollektion-austausch";

  function isMontiertYes(value) {
    if (!value) return false;
    var v = value.toString().trim().toLowerCase();
    return v === "montiert" || v === "ja" || v === "yes";
  }

  var wrappers = document.querySelectorAll("[data-buegel-assign]");
  if (!wrappers.length) return;

  var emptyText = "Lege zuerst eine Brille in den Warenkorb.";
  var placeholderText = "Brille im Warenkorb auswählen";

  var brilleItems = [];
  var fetchPromise = null;

  function isBrille(item) {
    if (!item) return false;
    if (item.handle === SELF_HANDLE) return false;
    var type = (item.product_type || "").toLowerCase();
    return type.indexOf("brille") !== -1;
  }

  function buildLabel(item) {
    var parts = [item.product_title || item.title || ""];
    if (item.variant_title && item.variant_title !== "Default Title") {
      parts.push(item.variant_title);
    }
    if (item.sku) {
      parts.push("SKU " + item.sku);
    }
    return parts.filter(Boolean).join(" – ");
  }

  function loadBrillen() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        brilleItems = [];
        var seen = {};
        for (var i = 0; i < items.length; i++) {
          if (!isBrille(items[i])) continue;
          var label = buildLabel(items[i]);
          if (!label || seen[label]) continue;
          seen[label] = true;
          brilleItems.push(label);
        }
        return brilleItems;
      })
      .catch(function () { return []; });
    return fetchPromise;
  }

  function populateSelect(select, options) {
    var current = select.value;
    while (select.options.length > 0) select.remove(0);
    var placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = placeholderText;
    select.appendChild(placeholder);
    for (var i = 0; i < options.length; i++) {
      var opt = document.createElement("option");
      opt.value = options[i];
      opt.textContent = options[i];
      select.appendChild(opt);
    }
    if (current && options.indexOf(current) !== -1) {
      select.value = current;
    }
  }

  function applyState(wrapper, montiertValue) {
    var select = wrapper.querySelector("[data-buegel-assign-select]");
    var emptyMsg = wrapper.querySelector("[data-buegel-assign-empty]");
    if (!select) return;

    var isYes = isMontiertYes(montiertValue);
    if (!isYes) {
      wrapper.hidden = true;
      select.disabled = true;
      select.required = false;
      if (emptyMsg) emptyMsg.hidden = true;
      return;
    }

    wrapper.hidden = false;
    if (brilleItems.length === 0) {
      select.disabled = true;
      select.required = false;
      if (emptyMsg) emptyMsg.hidden = false;
    } else {
      select.disabled = false;
      select.required = true;
      if (emptyMsg) emptyMsg.hidden = true;
    }
  }

  loadBrillen().then(function () {
    wrappers.forEach(function (wrapper) {
      var select = wrapper.querySelector("[data-buegel-assign-select]");
      if (select) populateSelect(select, brilleItems);
      applyState(wrapper, wrapper.getAttribute("data-initial-montiert") || "");
    });
  });

  document.addEventListener("variant:change", function (event) {
    var detail = event && event.detail;
    if (!detail || !detail.variant) return;
    wrappers.forEach(function (wrapper) {
      var idx = parseInt(wrapper.getAttribute("data-montiert-index"), 10);
      if (isNaN(idx) || idx < 0) return;
      var value = detail.variant.options ? detail.variant.options[idx] : "";
      applyState(wrapper, value || "");
    });
  });
})();

// ============================================================
// Bügel-Auto-Zuordnung: Wenn von einer Brillen-PDP über das
// Upsell-Widget (Essential Upsell) ein Bügel hinzugefügt wird,
// schreiben wir automatisch die aktuelle Brille als
// Line Item Property "Für Brille" in den Cart-Add-Request.
// Funktioniert via Fetch + XHR Interceptor.
// ============================================================
(function () {
  var BUEGEL_HANDLE = "bugel-3d-kollektion-austausch";
  var PROPERTY_NAME = "Für Brille";
  var BUEGEL_VARIANT_IDS = null;
  var CURRENT_BRILLE = null;

  var pathMatch = (location.pathname || "").match(/\/products\/([^\/\?]+)/);
  var currentHandle = pathMatch ? pathMatch[1] : null;

  function loadBuegelVariants() {
    return fetch("/products/" + BUEGEL_HANDLE + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        BUEGEL_VARIANT_IDS = {};
        (p.variants || []).forEach(function (v) { BUEGEL_VARIANT_IDS[v.id] = true; });
      })
      .catch(function () { BUEGEL_VARIANT_IDS = {}; });
  }

  function loadCurrentBrille() {
    if (!currentHandle || currentHandle === BUEGEL_HANDLE) return Promise.resolve();
    return fetch("/products/" + currentHandle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var type = (p.type || "").toLowerCase();
        if (type.indexOf("brille") === -1) return;
        CURRENT_BRILLE = p;
      })
      .catch(function () {});
  }

  loadBuegelVariants();
  loadCurrentBrille();

  function getCurrentVariantId() {
    var input = document.querySelector(
      '.product-single__form select[name="id"], .product-single__form [data-product-select], form[action*="/cart/add"] [name="id"]'
    );
    return input ? input.value : null;
  }

  function buildBrilleLabel() {
    if (!CURRENT_BRILLE) return null;
    var variantId = getCurrentVariantId();
    var variant = null;
    if (variantId) {
      variant = (CURRENT_BRILLE.variants || []).find(function (v) {
        return String(v.id) === String(variantId);
      });
    }
    if (!variant && CURRENT_BRILLE.variants && CURRENT_BRILLE.variants.length) {
      variant = CURRENT_BRILLE.variants[0];
    }
    var parts = [CURRENT_BRILLE.title];
    if (variant && variant.title && variant.title !== "Default Title") parts.push(variant.title);
    if (variant && variant.sku) parts.push("SKU " + variant.sku);
    return parts.filter(Boolean).join(" – ");
  }

  function isBuegelVariant(id) {
    if (!BUEGEL_VARIANT_IDS) return false;
    return !!BUEGEL_VARIANT_IDS[Number(id)];
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function injectIntoFormData(fd, label) {
    var changed = false;
    var directId = fd.get("id");
    if (directId && isBuegelVariant(directId)) {
      var propKey = "properties[" + PROPERTY_NAME + "]";
      if (!fd.has(propKey)) { fd.append(propKey, label); changed = true; }
    }
    for (var i = 0; i < 20; i++) {
      var itemId = fd.get("items[" + i + "][id]");
      if (itemId && isBuegelVariant(itemId)) {
        var itemPropKey = "items[" + i + "][properties][" + PROPERTY_NAME + "]";
        if (!fd.has(itemPropKey)) { fd.append(itemPropKey, label); changed = true; }
      }
    }
    return changed;
  }

  function injectIntoString(body, label) {
    try {
      var parsed = JSON.parse(body);
      var changed = false;
      if (parsed.id && isBuegelVariant(parsed.id)) {
        parsed.properties = parsed.properties || {};
        if (!parsed.properties[PROPERTY_NAME]) {
          parsed.properties[PROPERTY_NAME] = label;
          changed = true;
        }
      }
      if (Array.isArray(parsed.items)) {
        parsed.items.forEach(function (item) {
          if (item && isBuegelVariant(item.id)) {
            item.properties = item.properties || {};
            if (!item.properties[PROPERTY_NAME]) {
              item.properties[PROPERTY_NAME] = label;
              changed = true;
            }
          }
        });
      }
      return changed ? JSON.stringify(parsed) : body;
    } catch (e) {
      var params = new URLSearchParams(body);
      var pid = params.get("id");
      if (pid && isBuegelVariant(pid)) {
        var key = "properties[" + PROPERTY_NAME + "]";
        if (!params.has(key)) {
          params.append(key, label);
          return params.toString();
        }
      }
      return body;
    }
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url);
        if (isCartAddUrl(url) && init && init.body) {
          var label = buildBrilleLabel();
          if (label) {
            if (init.body instanceof FormData) {
              injectIntoFormData(init.body, label);
            } else if (typeof init.body === "string") {
              init.body = injectIntoString(init.body, label);
            }
          }
        }
      } catch (e) { /* never block the request */ }
      return originalFetch.apply(this, arguments);
    };
  }

  var XHRopen = XMLHttpRequest.prototype.open;
  var XHRsend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._mantiCartAdd = isCartAddUrl(url);
    return XHRopen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this._mantiCartAdd && body) {
        var label = buildBrilleLabel();
        if (label) {
          if (body instanceof FormData) {
            injectIntoFormData(body, label);
          } else if (typeof body === "string") {
            body = injectIntoString(body, label);
          }
        }
      }
    } catch (e) { /* never block */ }
    return XHRsend.call(this, body);
  };
})();
